var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"text-center pt-4 pb-1"},[_vm._v(_vm._s(_vm.player_name))]),_c('Resume',{attrs:{"data_resume":{
      data: _vm.items,
      keys: ['sum_bet', 'sum_comission'],
      showSum: true,
      hideAlert: true,
    }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }